import { Injectable } from '@angular/core';
import { NotificationsDataService } from '@app/pcs/shared/notifications/service/notifications-data-service';
import {
  PcsNotificationsActionsTypes
} from '@app/pcs/shared/notifications/store/actions/notifications-actions';
import * as PcsNotificationsActions from '@app/pcs/shared/notifications/store/actions/notifications-actions';
import { PcsNotifications } from '@app/pcs/shared/notifications/store/reducer/notifications';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  exhaustMap,
  of,
  switchMap
} from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class NotificationsEffects {

  fetchNotifications$ = createEffect(() => this.actions$.pipe(
    ofType<PcsNotificationsActions.FetchPcsNotifications>(PcsNotificationsActionsTypes.FetchNotifications),
    exhaustMap(() => this.notificationsDataService.fetchPcsNotifications()
      .pipe(
        switchMap((pcsNotifications: PcsNotifications) =>
          [new PcsNotificationsActions.FetchPcsNotificationsSuccess(pcsNotifications)]),
        catchError((error: Error) => of(new PcsNotificationsActions.FetchPcsNotificationsFailed(error)))
      ))
  ));

  constructor(private notificationsDataService: NotificationsDataService,
    private actions$: Actions) {
  }
}
